import type { PriceGridFilterConfig, PriceGridSourceItem } from '../../types';

export const CUSTOMER_PRICE_GRID_FILTER_CONFIG = {
  initialState: {},
} satisfies PriceGridFilterConfig<PriceGridSourceItem>;
